tinymce.baseURL = '/vendor/tinymce';
tinymce.init({
    selector: '.text-editor, .text-editor-with-anchor',
    height: 450,
    plugins: 'autolink table hr lists wordcount link code image',
    toolbar: 'formatselect | bold italic strikethrough | alignleft aligncenter alignright alignjustify  | image | numlist bullist outdent indent | removeformat | link | code',
    setup: function (editor) {
        editor.on('change', function () {
            tinymce.triggerSave();
        });
    }
});
